/* eslint-disable @typescript-eslint/explicit-function-return-type */
// We want to use the inferred return types from Jotai
import { useAtom, useAtomValue, useSetAtom, useStore } from 'jotai';

import type { Atom, PrimitiveAtom, SetStateAction, WritableAtom } from 'jotai';

// type SetAtom<Args extends unknown[], Result> = (...args: Args) => Result;

// We need to create custom hooks that use the store due to using NextJS
export const useJotaiAtom = <T>(atom: PrimitiveAtom<T>) => {
  return useAtom<T, [SetStateAction<T>], void>(atom, {
    store: useStore(),
  });
};

export const useJotaiValue = <T>(atom: Atom<T>) => {
  return useAtomValue(atom, {
    store: useStore(),
  });
};

export const useSetJotaiAtom = <T, U extends unknown[], V>(atom: WritableAtom<T, U, V>) => {
  return useSetAtom(atom, {
    store: useStore(),
  });
};

// TODO: resolve these types & maybe check other repos using Jotai
// export const useResetJotaiAtom = <T, U>(atom: WritableAtom<T, [typeof RESET], unknown>) => {
//   return useResetAtom(atom, {
//     store: useStore(),
//   });
// };
